import React from 'react';
import Resume from '../components/Resume';
import './ResumeContainer.css';

const ResumeContainer = () => {
  return (
    <div className="resume-page">
      <Resume />
    </div>
  );
};

export default ResumeContainer;
